import { darken, rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { translate } from '@vimeo/i18n-runtime';
import { slate, grayscale } from '@vimeo/iris/color';
import { Button } from '@vimeo/iris/components';
import { Header, Paragraph } from '@vimeo/iris/typography';

import { AlbumThemes } from './types';

type Props = {
  brandColor: string;
  customLogo: string | null;
  name: string;
  theme: AlbumThemes;
};

const UserNotAllowed = ({ brandColor, customLogo, name, theme }: Props) => {
  return (
    <Wrapper brandColor={brandColor} theme={theme}>
      {customLogo !== null && <CustomLogoImg src={customLogo} alt={name} />}
      <Header size="1">{translate('This account doesn’t have access')}</Header>
      <Paragraph size="1">
        {translate('Try again, or contact your team’s admin for help.')}
      </Paragraph>
      <TryAgainButton brandColor={brandColor} onClick={() => location.reload()}>
        {translate('Try again')}
      </TryAgainButton>
    </Wrapper>
  );
};

export default UserNotAllowed;

const Wrapper = styled.div<{ brandColor: string; theme: AlbumThemes }>`
  width: 100%;
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.theme === 'dark' ? grayscale(850) : 'inherit')};
  color: ${(props) => (props.theme === 'dark' ? 'white' : slate(800))};
  a {
    color: ${(props) => props.brandColor};
    text-decoration: none;
  }
  a:hover {
    color: ${(props) => darken(0.1, props.brandColor)};
  }
`;

const CustomLogoImg = styled.img`
  width: ${rem(185)};
  margin-bottom: ${rem(25)};
`;

const TryAgainButton = styled(Button)<{ brandColor: string }>`
  min-width: ${rem(350)};
  color: white;
  background-color: ${(props) => props.brandColor};
  border-color: ${(props) => props.brandColor};
  text-decoration: none;
  &:hover {
    background-color: ${(props) => darken(0.1, props.brandColor)};
    border-color: ${(props) => darken(0.1, props.brandColor)};
  }
`;
